<template>
  <v-app id="app" :class="{ 'is-mobile': mobile }">
    <router-view :language="language" :scroll="scroll" />
    <app-footer />
    <app-menu v-model="language" :languages="languages" :language="language" :scroll="scroll">
      <h2>{{ title }}</h2>
    </app-menu>
  </v-app>
</template>

<script>
import AppMenu from '@/components/Menu'
import AppFooter from '@/components/Footer'

export default {
  name: 'app',
  components: {
    AppMenu,
    AppFooter
  },
  data: () => ({
    title: 'Optik Pillwein',
    languages: ['de', 'en'],
    language: localStorage.getItem('vue-wp-pwa_language') || 'en',
    scrollPosition: 0,
    scrollDirection: 'down'
  }),
  watch: {
    language () { localStorage.setItem('vue-wp-pwa_language', this.language) }
  },
  mounted () {
    window.addEventListener('scroll', this.onScroll, { passive: true })
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.onScroll, { passive: true })
  },
  methods: {
    onScroll () {
      let position = window.pageYOffset || document.documentElement.scrollTop
      this.scrollDirection = this.scrollPosition < position ? 'down' : 'up'
      this.scrollPosition = position
    }
  },
  computed: {
    mobile () { return this.$vuetify.breakpoint.smAndDown },
    scroll () {
      return {
        position: this.scrollPosition,
        direction: this.scrollDirection
      }
    }
  }
}
</script>

<style lang="scss">
@import './styles/theme';

#app {
  font-family: $FONT;
  font-size: $FONT_SIZE;
  font-weight: $FONT_WEIGHT;
  letter-spacing: $FONT_SPACING;
  color: $COLOR_ACCENT_DARK;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  .view { min-height: 100vh; }
  .view-offset { padding-top: 150px; }
  .content-align-center { text-align: center; }

  h1 {
    font-size: 56px;
    font-weight: $FONT_WEIGHT;
    color: $COLOR_PRIMARY;
    margin-bottom: 12px;
  }

  h2 {
    font-size: 36px;
    font-weight: $FONT_WEIGHT;
    color: $COLOR_PRIMARY;
  }

  h3 {
    font-size: 28px;
    font-weight: $FONT_WEIGHT;
    color: $COLOR_PRIMARY;
  }

  &.is-mobile {
    h1 { font-size: 36px; }
    h2 { font-size: 28px; }
    h3 { font-size: 18px; }
  }
}
</style>
